<template>
    <Background
        :backPath="'prevPage'">
        <div class="info-area">
            <div class="title">
                识别系统信息
            </div>
            <div class="info-paragraph">
                <div class="info-line">
                    <div class="info-label">姓名</div>
                    <div class="content-area">
                        <div class="info-content">{{ displayName }}</div>
                        <a-icon
                            v-on:click="popEditDialog('displayName')"
                            class="edit-button"
                            type="highlight" />
                    </div>
                </div>

                <div class="info-line">
                    <div class="info-label">识别类型</div>
                    <div class="info-content">{{ roleName }}</div>
                </div>

                <div class="info-line">
                    <div class="info-label">识别系统ID</div>
                    <div class="info-content">{{ userId }}</div>
                </div>
            </div>
            <div class="info-paragraph">
                <div class="info-line">
                    <div class="info-label">登录手机号</div>
                    <div class="content-area">
                        <div class="info-content">{{ userName }}</div>
                        <a-icon
                            v-on:click="popEditDialog('userName')"
                            class="edit-button"
                            type="highlight"
                        />
                    </div>
                </div>
                <div class="info-line">
                    <div class="info-label">登录密码</div>
                    <div class="content-area">
                        <div class="info-content">******</div>
                        <a-icon
                            v-on:click="popEditDialog('password')"
                            class="edit-button"
                            type="highlight"
                        />
                    </div>
                </div>
                <div class="info-line" v-if="role == 28">
                    <div class="info-label">高级测验</div>
                    <div class="content-area">
                        <a-button
                            v-on:click="addHighLevelTestOrders"
                            size="large"
                            class="watch-shell-button">
                            增加高级测验题
                        </a-button>
                    </div>
                </div>
            </div>

          <template>
            <ve-table :columns="columns" :table-data="tableData" />
          </template>

            <div class="info-line-bottom"  v-if="role == 28">
                 <div class="info-label">初级测验错误订单</div>
                 <div class="content-area">
                       <div class="info-large-content">{{ levelOneWrongOrders }}</div>
                 </div>
            </div>
            <div class="info-line-bottom"  v-if="role == 28">
                <div class="info-label">高级测验错误订单</div>
                <div class="content-area">
                     <div class="info-large-content">{{ levelTwoWrongOrders }}</div>
                </div>
            </div>
            <div class="info-line-bottom" v-if="role == 27">
                <div class="info-label">该打标员最近复核出错的订单（最多50条）</div>
                <div class="content-area">
                     <div class="info-large-content">{{ lastMarkReviewDiffOrders }}</div>
                </div>
            </div>
            <a-button
                 v-on:click="deleteReviewer"
                 class="delete-button"
                 size="large"
                 type="danger">
                 删除识别系统
            </a-button>
        </div>
        <ReviewerEditDialog
            ref="dialog"
            :title="editInfoTitle"
            :hint="editInfoHint"
            :type="editInfoType"
            :inputType="editInfoInputType"
            :successMessage="editInfoSuccessMessage"
            :userId="editInfoUserId"
            :updateInfoCallback="updateInfo"
        />
    </Background>
</template>

<script>
 import Vue from 'vue';

 import Background from "./Background.vue"
 import VCharts from 'v-charts'
 import ReviewerEditDialog from "./ReviewerEditDialog.vue"
 import Modal from "ant-design-vue/lib/modal";
 import message from "ant-design-vue/lib/message";

 Vue.component(Modal.name, Modal);
 Vue.use(VCharts)
 export default {
     name: 'ReviewerInfo',
     data() {
         return {
             searchContent: "",
             userId: "",
             userName: "",
             role: 0,
             roleName: "",
             displayName: "",
             password: "",
             levelOneWrongOrders: "",
             levelTwoWrongOrders: "",
             lastMarkReviewDiffOrders: "",
             editInfoTitle: "",
             editInfoHint: "",
             editInfoType: "",
             editInfoInputType: "",
             editInfoSuccessMessage: "",
             editInfoUserId: 0,
             extend: {
                  series: {
                      label: { show: true, position: "top" }
                  }
              },
             colors: ['#5295E4', '#c23531','#2f4554', '#61a0a8',
                                   '#d48265', '#91c7ae','#749f83',
                                   '#ca8622', '#bda29a','#6e7074',
                                   '#546570', '#c4ccd3'],
           columns: [
             { field: "date", key: "d", title: "日期", align: "center" },
             { field: "count", key: "c", title: "单数", align: "center" },
             { field: "total", key: "t", title: "平台总单数", align: "center" },
             { field: "reviewCount", key: "rc", title: "复核正确单数", align: "center" },
             { field: "reviewTotal", key: "rt", title: "复核总单数", align: "center" },
             { field: "reviewPecent", key: "rp", title: "复核准确率", align: "center" },
             { field: "unfinishedCount", key: "uc", title: "刷单数", align: "center" },
             { field: "unfinishedTotal", key: "ut", title: "平台总刷单数", align: "center" },
             { field: "nightCount", key: "uc", title: "夜间订单数", align: "center" },
             { field: "nightCountTotal", key: "ut", title: "平台总夜间订单数", align: "center" },
           ],
           tableData: [],
         }
     },
     props: {
     },
     components: {
         Background,
         ReviewerEditDialog
     },
     computed: {
     },
     mounted() {
         var info = JSON.parse(sessionStorage.getItem("clickReviewerInfo"))

         this.userId = info.UserId
         this.userName = info.Username
         this.role = "" + info.Role
         this.displayName = info.DisplayName
         this.levelOneWrongOrders = info.LevelOneWrongOrders
         this.levelTwoWrongOrders = info.LevelTwoWrongOrders
         this.lastMarkReviewDiffOrders = JSON.stringify(info.LastMarkReviewDiffOrders)
         if (info.Role == 25) {
             this.roleName = "识别管理员"
         } else if (info.Role == 26) {
             this.roleName = "长识别账号"
         } else if (info.Role == 27) {
             this.roleName = "短识别账号"
         } else if (info.Role == 28) {
             this.roleName = "测验账号"
         } else if (info.Role == 29) {
             this.roleName = "复核账号"
         }

         var url = process.env.VUE_APP_API_SERVER + '/marker/rank-for-day/' + this.userId
         var accessToken = localStorage.getItem('accessToken')

         var that = this
          fetch(url, {
              method: "GET",
              headers: new Headers({
                  'Content-Type': 'application/json',
                  'Access-Token': accessToken
              })
          }).then(res => {
              if (!res.ok) { throw res }
              return res.json()
          }).catch(error => {
              console.log(error)
          }).then(response => {
              var rows = []

              for (var i = 0; i < response.length; i++) {
                  var percent =  Math.round(response[i].ReviewCount / response[i].ReviewTotal * 10000) / 100.00 + "%"
                  if (response[i].ReviewTotal == 0) {
                      percent = "无"
                  }
                  rows.push({
                    date: response[i].Date,
                    count: response[i].Count,
                    total: response[i].Total,
                    unfinishedCount: response[i].UnfinishedCount,
                    unfinishedTotal: response[i].UnfinishedTotal,
                    reviewCount: response[i].ReviewCount,
                    reviewTotal: response[i].ReviewTotal,
                    reviewPecent: percent,
                    nightCount: response[i].NightCount,
                    nightCountTotal: response[i].NightCountTotal,
                  })
              }
              this.tableData = rows
          })
     },
     methods: {
         popEditDialog(type) {
             if (type == "displayName") {
                 this.editInfoTitle = "编辑姓名",
                 this.editInfoHint = "请输入姓名"
                 this.editInfoSuccessMessage = "姓名更新成功"
                 this.editInfoInputType = "text"
             } else if (type == "userName") {
                 this.editInfoTitle = "编辑登录手机号",
                 this.editInfoHint = "请从手机号"
                 this.editInfoSuccessMessage = "手机号更新成功"
                 this.editInfoInputType = "text"
             } else if (type == "password") {
                 this.editInfoTitle = "编辑登录密码",
                 this.editInfoHint = "请输入登录密码"
                 this.editInfoSuccessMessage = "密码更新成功"
                 this.editInfoInputType = "password"
             }

             this.editInfoUserId = this.userId
             this.editInfoType = type
             this.$refs.dialog.show()
         },
         updateInfo(type, info) {
             if (type == "displayName") {
                 this.displayName = info
             } else if (type == "userName") {
                 this.userName = info
             } else if (type == "password") {
                 this.password = info
             }
         },
         typeChange (e) {
             var url = process.env.VUE_APP_API_SERVER + '/marker/' + this.userId
             var accessToken = localStorage.getItem('accessToken')

             var data = {
                 Role: parseInt(e.target.value)
             }

             var that = this
             fetch(url, {
                 method: "PUT",
                 body: JSON.stringify(data),
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }).then(res => {
                 if (!res.ok) { throw res }
                 return res.json()
             }).catch(error => {
                 message.success("切换识别系统类型失败，请稍后再试")

                 if (e.target.value == "27") {
                     that.role = "26"
                 } else if (e.target.value == "26") {
                     that.role = "27"
                 }
             }).then(response => {
                 if (e.target.value == "27") {
                     message.success("切换短识别系统成功")
                 } else if (e.target.value == "26") {
                     message.success("切换长识别系统成功")
                 }
             })
         },
         deleteReviewer() {
             const modal = Modal.confirm();
             var that = this
             modal.update({
                 title: "删除识别系统",
                 content: '确定要删除此识别系统吗?',
                 centered: true,
                 okText: "确认",
                 cancelText: "取消",
                 onOk() {
                     const url = `${process.env.VUE_APP_API_SERVER}/marker/${that.userId}`;
                     var accessToken = localStorage.getItem('accessToken')

                     fetch(url, {
                         method: 'DELETE',
                         headers: new Headers({
                             'Content-Type': 'application/json',
                             'Access-Token': accessToken
                         })
                     }
                     ).then(res => res.json()
                     ).catch(error => {
                         console.log("Error: ", error)
                     }).then(response => {
                         that.$router.go(-1)
                     })
                 }
             })
         },
         addHighLevelTestOrders() {
              var that = this
              if (that.role != "28") {
                  message.error("非测验账号不能添加高级测验题")
                  return
               }
              const modal = Modal.confirm();
              modal.update({
                  title: "高级测验",
                  content: '确定要增加高级测验题吗?',
                  centered: true,
                  okText: "确认",
                  cancelText: "取消",
                  onOk() {
                      const url = `${process.env.VUE_APP_API_SERVER}/marker/addHighLevelTestOrders/${that.userId}`;
                      var accessToken = localStorage.getItem('accessToken')

                      fetch(url, {
                          method: 'POST',
                          headers: new Headers({
                              'Content-Type': 'application/json',
                              'Access-Token': accessToken
                          })
                      }
                      ).then(res => {
                         if (!res.ok) { throw res }
                         return res.json()
                     }
                      ).catch(error => {
                          message.error("增加高级测验题失败，请联系技术处理")
                      }).then(response => {
                      })
                  }
              })
          }

     },
 }
</script>

<style scoped>
 .info-area {
     width: 100%;
     height: 100%;
     padding-top: 80px;
     padding-left: 80px;
     padding-right: 80px;

     background-color: #FFF;

     position: relative;
 }

 .title {
     font-size: 24px;
     margin-left: 30px;
     margin-bottom: 20px;
     text-align: start;
 }

 .info-line {
     display: flex;
     flex-direction: column;
     justify-content: flex-start;
     width: 100%;
     border-right: 1px solid #EEE;
     padding-left: 30px;
 }

 .info-line:last-child {
     border-right: none;
 }

 .info-line-bottom {
     display: flex;
     flex-direction: column;
     justify-content: flex-start;
     width: 100%;
     border-right: 1px solid #EEE;
     padding-top: 30px;
     padding-left: 30px;
 }
 .info-label {
     font-size: 18px;
     color: #333;
     width: 400px;
     text-align: start;
     margin-bottom: 10px;
     user-select: none;
 }

 .info-content {
     font-size: 16px;
     color: #999;
     text-align: start;
     height: 24px;
 }

 .info-large-content {
     font-size: 16px;
     color: #999;
     text-align: start;
     height: 100%;
 }

 .info-paragraph {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: space-around;
     padding-top: 30px;
     padding-bottom: 30px;
     border-bottom: 1px solid #EFEFEF;
 }

 .content-area {
     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .edit-button {
     margin-left: 5px;
     margin-bottom: 2px;
     font-size: 16px;
     color: #333;
     cursor: pointer;
 }

 .edit-button:hover {
     color: #587FE0;
 }

 .delete-button {
     position: absolute;
     margin-top: 10px;
     margin-bottom: 40px;
 }

 .type-check-group {
     display: flex;
 }

  .histogram-area {
      padding: 40px;
  }
</style>
